import {useEffect, useRef, useState} from "react";
import {getDatalabAnalysisDashboardChartAll} from "@/pages/dashboard/services/datalab";

export default function useAllData(dashboardUuid, queries) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(undefined);
  // 统计指标数据
  const ref = useRef({queries})

  useEffect(() => {
    const { queries: preQueries } = ref.current;
    if (!queries?.filters?.length || (preQueries === queries)) return;
    setError(undefined);
    // setLoading(true);
    // setData({});
    const params = {
      dashboard_uuid: dashboardUuid,
      queries: {
        ...queries,
        orderby :[]
      },
      page: 1,
      pagesize: 2000,
    }
    getDatalabAnalysisDashboardChartAll(params).then((res) => {
      setData(res|| {});
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setError(error);
      console.log("请求图表数据错误: ", error);
    });

  }, [queries])
  // 只有当dashboardUuid 和 queries都有改变时才请求图表数据
  // 但 queries的值需要等到异步请求成功后才能变化, 一直晚于 dashboardUuid, 所以只依赖了queries
  return { loading, error, data, setData, setLoading }
}
